<main>
	<router-outlet />
	<app-settings-button></app-settings-button>
</main>